const GET_STATUS = 'GET_STATUS';
const SET_STATUS = 'SET_STATUS';

export
{
    GET_STATUS,
    SET_STATUS
};
